// Observer mode's play loop timer (Section 3 observer, 22). Lives apart from the observer
// actions so game actions can stop it without an import cycle.
import { patchUi } from '../state';

let timer: ReturnType<typeof setInterval> | null = null;

export function startObserverTimer(tick: () => void, intervalMs: number): void {
  if (timer !== null) clearInterval(timer);
  timer = setInterval(tick, intervalMs);
  patchUi({ observerRunning: true });
}

export function stopObserver(): void {
  if (timer !== null) clearInterval(timer);
  timer = null;
  patchUi({ observerRunning: false });
}
